export let TRANS_UNION_FAILURE = {
    "main_application" : 0,
}